type SearchHit = {
  url?: string;
  slug?: string;
  actions?: { title?: string; url?: string }[];
  consult_services?: { id?: string | number }[];
};

/**
 * Where a suggested online-visit doctor (a search hit) should take the patient:
 * straight to the online invoice (`/factor/v2/<slug>/<serviceId>/`), like search results do.
 * Falls back to the booking flow when the hit carries no consult service id.
 */
export function onlineVisitFactorUrl(doctor: SearchHit | undefined) {
  const slug = doctor?.slug || doctor?.url?.match(/\/dr\/([^/?#]+)/)?.[1] || '';
  const actionUrl = doctor?.actions?.find(item => item?.title === 'ویزیت آنلاین')?.url ?? '';
  const factorPath = actionUrl.match(/\/factor\/v2\/[^?#]+/)?.[0];
  if (factorPath) return factorPath.endsWith('/') ? factorPath : `${factorPath}/`;
  const serviceId = actionUrl.match(/serviceId=([^&]+)/)?.[1] ?? doctor?.consult_services?.[0]?.id;
  if (slug && serviceId) return `/factor/v2/${slug}/${serviceId}/`;
  return `/booking/${slug}/?centerId=5532&skipTimeSelectStep=true`;
}
